import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageContainerComponent } from './page-container/page-container.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { CountCardComponent } from './count-card/count-card.component';
import { LoaderComponent } from './loader/loader.component';
import { AlertComponent } from './alert/alert.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DialogComponent } from './dialog/dialog.component';
import { ModalComponent } from './modal/modal.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { LineChartComponent } from './line-chart/line-chart.component';
import { CustomHeaderComponent } from './chart-header/custom-header.component';
import { LineGraphCommonChartComponent } from './line-graph-common-chart/line-graph-common-chart.component';
import { OvalShappedGraphLabelComponent } from './oval-shaped-graph-label/oval-shaped-graph-label.component';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';
import { ExportDialogComponent } from './export-dialog/export-dialog.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ServiceDetailsBubbleChartComponent } from './service-details-bubble-chart/service-details-bubble-chart.component';
import { InitialRouteResolverComponent } from './initial-route-resolver/initial-route-resolver.component';
import { BenchmarkComponent } from './benchmark/benchmark.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { InformationTooltipComponent } from './information-tooltip/information-tooltip.component';
import { PresentationOptionsComponent } from './presentation-options/presentation-options.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { SingleSelectInputComponent } from './single-select-input/single-select-input.component';
import { MultiSelectInputComponent } from './multi-select-input/multi-select-input.component';

@NgModule({
  declarations: [
    PageContainerComponent,
    CountCardComponent,
    LoaderComponent,
    AlertComponent,
    DialogComponent,
    ModalComponent,
    ProgressBarComponent,
    LineChartComponent,
    CustomHeaderComponent,
    LineGraphCommonChartComponent,
    OvalShappedGraphLabelComponent,
    DoughnutChartComponent,
    ExportDialogComponent,
    ServiceDetailsBubbleChartComponent,
    InitialRouteResolverComponent,
    BenchmarkComponent,
    ToggleSwitchComponent,
    InformationTooltipComponent,
    PresentationOptionsComponent,
    PaginatorComponent,
    SingleSelectInputComponent,
    MultiSelectInputComponent,
  ],
  exports: [
    PageContainerComponent,
    CountCardComponent,
    LoaderComponent,
    AlertComponent,
    DialogComponent,
    ModalComponent,
    ProgressBarComponent,
    LineChartComponent,
    CustomHeaderComponent,
    LineGraphCommonChartComponent,
    OvalShappedGraphLabelComponent,
    DoughnutChartComponent,
    ServiceDetailsBubbleChartComponent,
    ExportDialogComponent,
    BenchmarkComponent,
    ToggleSwitchComponent,
    InformationTooltipComponent,
    PresentationOptionsComponent,
    PaginatorComponent,
    SingleSelectInputComponent,
    MultiSelectInputComponent,
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatChipsModule,
    MatIconModule,
    ScrollingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    SlickCarouselModule,
  ],
})
export class EbrCoreModule {}
